import { resetState } from "../store/actionCreator"
import { clearAuthStorage } from "./authStorage"

export const handleError = (err, dispatch, history) => {
    if (err?.response?.status === 401) {
        clearAuthStorage()
        dispatch(resetState())
        history.push('/login')
    }
}
